import BaseApi from '@lumapps/base-api';
import { ServerListResponse } from '@lumapps/base-api/types';
import { CustomContentType } from '@lumapps/content-types/types';

import { Template } from '../types';

const MAX_RESULTS = 100;

export const templateApi = new BaseApi({ path: 'template' });

export interface ListAPIParams {
    customContentType: CustomContentType['id'];
    instance: string;
    lang?: string;
    maxResults?: number;
    cursor?: string;
    showTemplatesWithInheritedOnlyParam?: boolean;
    fields?: string;
    requestKey?: string;
}

export const list = async (
    {
        cursor,
        customContentType,
        instance,
        lang,
        maxResults = MAX_RESULTS,
        showTemplatesWithInheritedOnlyParam = true,
        fields,
    }: ListAPIParams,
    signal?: AbortSignal,
) => {
    const { data } = await templateApi.get<ServerListResponse<Template>>(
        'list',
        {
            params: {
                fields,
                cursor,
                customContentType,
                instance,
                lang,
                maxResults,
                ...(!showTemplatesWithInheritedOnlyParam && { visibleInheritedOnly: false }),
            },
            signal,
        },
        true,
    );

    return data;
};

export interface DeleteTemplateAPIParams {
    uid: string[];
}

export const remove = async (params: DeleteTemplateAPIParams = { uid: [] }) => {
    return templateApi.delete('deleteMulti', { params });
};

export const templateQueryKeys = {
    all: (customContentType: string) => [customContentType, 'template'] as const,
    list: (params: ListAPIParams) => [...templateQueryKeys.all(params.customContentType), 'list', params],
    delete: (params: DeleteTemplateAPIParams) => ['delete', params],
};
